/**
 * 上架 App 类型
 */
export const APP_TYPE_ALG = 1
export const APP_TYPE_CLB = 2

export const appTypeOptions = [
  {value: APP_TYPE_ALG, label: '爱零工'},
  {value: APP_TYPE_CLB, label: '查理宝'},
]

export function getAppTypeLabel (value) {
  const item = appTypeOptions.find(option => Number(option.value) === Number(value))
  return item ? item.label : ''
}



// WEBPACK FOOTER //
// ./core/utils/appType.js